import React from 'react';

import PropTypes from 'prop-types';
import Heading from '@tds/core-heading';

import FilesListRow from './filesListRow';

const FilesList = ({ filesList, removeFileFromList, orderId }) => {
  return (
    <>
      <div className="card">
        <div className="card-header">
          <Heading level="h4">List of user uploaded files</Heading>
        </div>
        <ul className="list-group list-group-flush">
          {filesList.map(file => (
            <FilesListRow
              key={file.fileId}
              orderId={orderId}
              fileData={file}
              removeFileFromList={removeFileFromList}
            />
          ))}
        </ul>
      </div>
    </>
  );
};

FilesList.propTypes = {
  filesList: PropTypes.arrayOf(PropTypes.object).isRequired,
  removeFileFromList: PropTypes.func.isRequired,
  orderId: PropTypes.number.isRequired
};

export default FilesList;
